var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "outside-click-listener",
    {
      staticClass: "relative",
      on: {
        clickoutside: function ($event) {
          _vm.isOpened = false
        },
      },
    },
    [
      _c("search-form-input", {
        staticClass: "cursor-pointer text-blue",
        attrs: {
          label: _vm.label,
          value: _vm.valueToDisplay,
          isOpened: _vm.isOpened,
          readonly: true,
        },
        on: { openstatechange: _vm.handleOpenStateChange },
      }),
      _vm._v(" "),
      _c(
        "svg",
        {
          staticClass:
            "absolute top-1/2 -translate-y-1/2 right-4 lg:right-6 pointer-events-none",
          attrs: {
            width: "25",
            height: "24",
            viewBox: "0 0 25 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M7.25 9.375L12.5 14.625L17.75 9.375",
              stroke: "currentcolor",
              "stroke-width": "1.5",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _vm.value.length
        ? _c("close-button", { on: { click: _vm.handleClearClick } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpened,
              expression: "isOpened",
            },
          ],
          staticClass: "search-form-dropdown",
          class: { "min-w-[16rem] max-w-screen": _vm.multiple },
          staticStyle: { display: "none" },
        },
        [
          _vm._l(_vm.optionGroups, function (group) {
            return _c(
              "div",
              {
                key: group.id,
                staticClass:
                  "grid gap-2 px-4 lg:px-2 2xl:px-4 border-t border-gray",
                class: { "py-4": group.label, "py-2": !group.label },
              },
              [
                group.label
                  ? _c("div", {
                      staticClass:
                        "block text-[.75rem] leading-none -tracking-[0.04em] text-zinc-600 pl-4",
                      domProps: { textContent: _vm._s(group.label) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(group.options, function (option) {
                  return _c("choice-option", {
                    key: option.value,
                    staticClass: "custom-choice-option cursor-pointer",
                    class: {
                      "bg-stone-50":
                        !_vm.multiple && _vm.valueIsInSelection(option.value),
                      "custom-choice-option--big": _vm.multiple,
                    },
                    attrs: {
                      multiple: _vm.multiple,
                      label: option.label,
                      name: _vm.name,
                      valueAttr: option.value,
                      value: _vm.valueIsInSelection(option.value),
                    },
                    on: {
                      input: (checked) =>
                        _vm.handleChange(checked, option.value),
                    },
                  })
                }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.multiple
            ? _c(
                "div",
                {
                  staticClass:
                    "px-4 lg:px-2 2xl:px-4 border-t border-gray py-2",
                },
                [
                  _c("button", {
                    staticClass:
                      "custom-choice-option text-[500] bg-blue text-white w-full justify-center hover:bg-blue focus:bg-blue",
                    attrs: { type: "button" },
                    domProps: { textContent: _vm._s(_vm.t.apply) },
                    on: {
                      click: function ($event) {
                        _vm.isOpened = false
                      },
                    },
                  }),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }